import React from 'react';
import { Modal } from 'syngenta-digital-cropwise-react-ui-kit';

import InfoIcon from 'assets/info.svg?react';
import { LayoutStrings } from '../Constants/layoutStrings';

interface ShowFutureWeatherConfirmModalProps {
  onSave: () => void;
  onContinueEditing: () => void;
  isEditMode?: boolean;
}

const showFutureWeatherConfirmModal = ({
  onSave,
  onContinueEditing,
  isEditMode = false
}: ShowFutureWeatherConfirmModalProps) => {
  const title = isEditMode
    ? 'Automatic weather added'
    : 'No future weather data';

  const content = isEditMode ? (
    <div style={{ marginLeft: 36 }}>
      <p style={{ margin: 0 }}>
        Due to the preferences that were set when this record was created,
        weather data has been added to this Application. Continue editing this
        record to view the weather data.
      </p>
    </div>
  ) : (
    <div style={{ marginLeft: 36 }}>
      <p style={{ margin: 0 }}>
        Weather data cannot be added to Applications that occur in the future.
      </p>
      <br />
      <p style={{ margin: 0 }}>
        To populate weather data, you&apos;ll need to edit this record after the
        End Date &amp; Time has occurred.
      </p>
    </div>
  );

  Modal.confirm({
    icon: (
      <span className="flex items-center" style={{ gap: 12 }}>
        <span className="flex items-center">
          <InfoIcon width={24} height={24} style={{ color: '#0092E4' }} />
        </span>
        <span
          className="font-semibold"
          style={{ fontSize: 18, color: '#14151C' }}
        >
          {title}
        </span>
      </span>
    ),
    content,
    okText: LayoutStrings.modals.buttonText.saveApplication,
    cancelText: LayoutStrings.modals.buttonText.continueEditing,
    centered: true,
    closable: false,
    maskClosable: false,
    transitionName: '',
    maskTransitionName: '',
    width: 493,
    bodyStyle: {
      padding: 16
    },
    okButtonProps: {
      style: {
        background: 'var(--Green-green-60, #14803C)',
        color: 'var(--Neutral-neutral-00, #FFF)',
        marginLeft: 8,
        padding: '10px 16px',
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 400
      }
    },
    cancelButtonProps: {
      style: {
        background: 'var(--Neutral-neutral-00, #FFF)',
        color: 'var(--Neutral-neutral-100, #14151C)',
        marginRight: 0,
        padding: '10px 16px',
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 400,
        border: '1px solid var(--Neutral-neutral-30, #C2C7D0)'
      }
    },
    onOk: onSave,
    onCancel: onContinueEditing
  });
};

export default showFutureWeatherConfirmModal;
